import {
  IonCol,
  IonRow,
  IonButtons,
  IonButton,
  IonIcon,
  IonGrid,
  IonRippleEffect,
} from '@ionic/react';
import StoreMenu from '../../../storeMenu/storeMenu';
import { Routes } from '../../../../utils/user/routes';
import classes from './styles.module.scss';
import { useMemo, useState } from 'react';
import Menu from '../../../storeMenu/menu';
import { useHistory, useLocation } from 'react-router';
import SearchBar from '../searchBar/searchBar';
import { DecodedToken } from '../../../../utils/getClientInfo';
import logo from '../../../../Assets/logo/logo_white_background_96.svg';
import { authService } from '../../../../utils/authService';
import { IoCartOutline } from 'react-icons/io5';
import useGlobalContext from '../../../../hooks/useStore';

const Desktop = ({
  user,
  backgroundColor,
}: {
  backgroundColor?: 'primary' | 'white' | 'transparent';
  user: any;
}) => {
  const userService = useMemo(
    () => authService.getCurrentUser() as DecodedToken,
    []
  );
  const globalState = useGlobalContext();
  const _isloggedIn = userService.id;
  const location = useLocation();
  const history = useHistory();
  const [open, setOpen] = useState<{ isOpen: boolean; event: Event | null }>({
    isOpen: false,
    event: null,
  });

  const openCntx = (e: any) => {
    setOpen({ isOpen: !open.isOpen, event: e });
    console.log(e);
  };

  return (
    <div className={classes.desktop + ' !size-full'}>
      {_isloggedIn >= 1 && (
        <Menu
          open={open.isOpen}
          close={openCntx}
          userDetails={user}
          openEvent={open.event!}
        />
      )}
      <IonGrid
        style={{
          background: 'white',
        }}
        className={classes.holder + ' !size-full'}
      >
        <IonRow className="size-full">
          <IonCol size={'2'} className={classes.logo}>
            <div
              className={classes.holder}
              onClick={() => {
                history.push('');
              }}
            >
              <IonIcon
                src={logo}
                className="aspect-square h-full w-auto mx-2 "
              ></IonIcon>
              <span
                className={classes.span1}
                style={{
                  color: 'var(--ion-color-primary)',
                }}
              >
                Bazaar
              </span>{' '}
              <span className={classes.span2}>Cheap</span>
            </div>
          </IonCol>
          <IonCol size="6.7" className={classes.navlinks}>
            <div className={'h-full flex items-center justify-end'}>
              {Routes.map((item, index) => {
                if (item.disabled) return null;
                if (item.isloggedIn && !userService.id) return null;
                return (
                  <span
                    onClick={() => {
                      history.push(item.route);
                    }}
                    className={`px-2 cursor-pointer text-base justify-center text-primary font-semibold  hover:underline hover:decoration-2 hover:underline-offset-4 ${
                      location.pathname === item.route &&
                      'underline decoration-2 underline-offset-4'
                    }`}
                    key={index}
                  >
                    {item.name}
                  </span>
                );
              })}
            </div>
          </IonCol>

          {/* Search disabled for first version  */}
          <IonCol
            size="0" // change this in time
            className={classes.search}
            style={{ display: 'none' }}
          >
            <div className={classes.holder}>
              {location.pathname !== '/' && location.pathname !== '/search' && (
                <SearchBar />
              )}
            </div>
          </IonCol>

          <IonCol
            size="0.7" // change this in time
            className="flex itemss-center justify-center"
          >
            {!location.pathname.includes('cart') && (
              <div className="w-fit h-full grid grid-cols-2 grid-flow-col-dense">
                <div
                  onClick={async () => {
                    history.push('/cart');
                  }}
                  className="size-8 my-auto flex items-center justify-center cursor-pointer ion-activatable ripple-parent circle rounded-full relative p-[0.5%] overflow-hidden"
                >
                  <IonRippleEffect />
                  <IoCartOutline
                    size="100%"
                    className="text-primary w-auto h-8 aspect-square"
                  />
                </div>
                {globalState.cartState.count ? (
                  <div className="mt-[1dvh] w-fit h-fit px-2 text-gray-50 font-roboto font-semibold rounded-full bg-primary flex items-center justify-center text-xs">
                    {globalState.cartState.count!}
                  </div>
                ) : (
                  ''
                )}
              </div>
            )}
          </IonCol>

          <IonCol size="2" className={classes.storeMenu}>
            {_isloggedIn ? (
              <div className={classes.chip}>
                <StoreMenu
                  userDetails={user}
                  open={open.isOpen}
                  openCntx={openCntx}
                />
              </div>
            ) : (
              <div className="">
                <IonButtons>
                  <IonButton
                    routerLink="/login"
                    color="primary"
                    fill="clear"
                    className="text-sm"
                  >
                    Log In
                  </IonButton>
                  <div className="h-7 w-0.5 bg-primary"></div>
                  <IonButton
                    routerLink="/signup"
                    color="primary"
                    fill="clear"
                    className="text-sm"
                  >
                    Sign Up
                  </IonButton>
                </IonButtons>
              </div>
            )}
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
};
export default Desktop;
